import * as React from "react";
import { connect } from "react-redux";

import { isRequestActive } from "redux-request-loading";

import { DashboardIcon } from "@teamprevent/common/dashboard";

import { CaseType } from "@teamprevent/common/model";

import { ApplicationState } from "../../applicationState";
import { LOAD_OH_CASE_COUNT, LOAD_WORK_ADJUSTMENT_COUNT } from "../actionTypes";
import { DashboardCaseType } from "../model";

interface StateProps {
    caseCount: { type: DashboardCaseType; count: number }[];
    loading: boolean;
    label: string;
    include: DashboardCaseType;
    iconSource?: string;
}

const Cases: React.FunctionComponent<StateProps> = (props: StateProps) => {

    const buildUrl = (): string => {
        const viewType = props.include === CaseType.WORK_ADJUSTMENT ? "workadjustments" : "ohCases";
        return `/${viewType}`;
    };

    const getCount = (): number => props.caseCount.find(cc => cc.type === props.include)?.count;

    return (
        <DashboardIcon href={buildUrl()} icon={props.iconSource ? props.iconSource : "/assets/cases.svg"} label={props.label} count={getCount()} />
    );
};

function mapStateToProps(state: ApplicationState) {
    return {
        caseCount: state.dashboard.caseCount,
        loading: isRequestActive(state, LOAD_OH_CASE_COUNT) || isRequestActive(state, LOAD_WORK_ADJUSTMENT_COUNT)
    };
}

export default connect(mapStateToProps)(Cases);
